module.exports = __webpack_public_path__ + "img/xp1_004.a8bf917f.jpg";